import {
  INVOICE_SUB_AGENT_INTERNAL_CREATE_FAIL,
  INVOICE_SUB_AGENT_INTERNAL_CREATE_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_CREATE_RESET,
  INVOICE_SUB_AGENT_INTERNAL_CREATE_SUCCESS,
  INVOICE_SUB_AGENT_INTERNAL_DELETE_FAIL,
  INVOICE_SUB_AGENT_INTERNAL_DELETE_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_DELETE_SUCCESS,
  INVOICE_SUB_AGENT_INTERNAL_GET_FAIL,
  INVOICE_SUB_AGENT_INTERNAL_GET_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_GET_SUCCESS,
  INVOICE_SUB_AGENT_INTERNAL_LIST_FAIL,
  INVOICE_SUB_AGENT_INTERNAL_LIST_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_LIST_SUCCESS,
  INVOICE_SUB_AGENT_INTERNAL_UPDATE_FAIL,
  INVOICE_SUB_AGENT_INTERNAL_UPDATE_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_UPDATE_SUCCESS,
} from "../constants/invoiceSubAgentInternalConstants";

export const subAgentInvoiceInternalListReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_SUB_AGENT_INTERNAL_LIST_REQUEST:
      return { loading: true };
    case INVOICE_SUB_AGENT_INTERNAL_LIST_SUCCESS:
      return { loading: false, subagentInternalInvoices: action.payload };
    case INVOICE_SUB_AGENT_INTERNAL_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const subAgentInvoiceInternalCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_SUB_AGENT_INTERNAL_CREATE_REQUEST:
      return { loading: true };
    case INVOICE_SUB_AGENT_INTERNAL_CREATE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_SUB_AGENT_INTERNAL_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case INVOICE_SUB_AGENT_INTERNAL_CREATE_RESET:
      return { loading: false, success: "" };
    default:
      return state;
  }
};

export const subAgentInvoiceInternalGetReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_SUB_AGENT_INTERNAL_GET_REQUEST:
      return { loading: true };
    case INVOICE_SUB_AGENT_INTERNAL_GET_SUCCESS:
      return { loading: false, subagentInternalInvoiceDet: action.payload };
    case INVOICE_SUB_AGENT_INTERNAL_GET_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const subAgentInvoiceInternalUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_SUB_AGENT_INTERNAL_UPDATE_REQUEST:
      return { loading: true };
    case INVOICE_SUB_AGENT_INTERNAL_UPDATE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_SUB_AGENT_INTERNAL_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const subAgentInvoiceInternalDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_SUB_AGENT_INTERNAL_DELETE_REQUEST:
      return { loading: true };
    case INVOICE_SUB_AGENT_INTERNAL_DELETE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_SUB_AGENT_INTERNAL_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
